/* Native Shopify multipart uploads. Configuration and markup are rendered in Liquid. */
(() => {
  const fpMessages = {"en":{"updating":"Updating your selection…","ready":"Photo selected — ready to add to your order.","choose_photo":"Please choose a photo for your design.","choose_format":"Please choose a JPG, PNG, WebP or HEIC photo.","supported":"Please choose a supported image file.","empty_file":"This file is empty. Please choose another photo.","large_file":"Your photo is larger than 20 MB. Please choose a smaller image.","selected":"Photo selected — it will upload when you add to cart.","wait_variant":"Please wait for your selection to finish updating. If it does not update, select the option again.","enter_name":"Please enter the name to print on your design.","total_size":"Please keep your photos under 20 MB in total. Choose smaller images and try again.","reselect":"Please select your product option again before adding to cart."},"de":{"updating":"Deine Auswahl wird aktualisiert…","ready":"Foto ausgewählt — bereit für deine Bestellung.","choose_photo":"Bitte wähle ein Foto für dein Design aus.","choose_format":"Bitte wähle ein Foto im Format JPG, PNG, WebP oder HEIC.","supported":"Bitte wähle eine unterstützte Bilddatei.","empty_file":"Diese Datei ist leer. Bitte wähle ein anderes Foto.","large_file":"Dein Foto ist größer als 20 MB. Bitte wähle ein kleineres Bild.","selected":"Foto ausgewählt — es wird beim Hinzufügen zum Warenkorb hochgeladen.","wait_variant":"Bitte warte, bis deine Auswahl aktualisiert wurde. Falls nichts passiert, wähle die Option erneut aus.","enter_name":"Bitte gib den Namen ein, der auf dein Design gedruckt werden soll.","total_size":"Deine Fotos dürfen zusammen höchstens 20 MB groß sein. Wähle kleinere Bilder und versuche es erneut.","reselect":"Bitte wähle deine Produktoption erneut aus, bevor du den Artikel in den Warenkorb legst."},"fr":{"updating":"Mise à jour de votre sélection…","ready":"Photo sélectionnée — prête à être ajoutée à votre commande.","choose_photo":"Veuillez choisir une photo pour votre modèle.","choose_format":"Veuillez choisir une photo au format JPG, PNG, WebP ou HEIC.","supported":"Veuillez choisir un fichier image pris en charge.","empty_file":"Ce fichier est vide. Veuillez choisir une autre photo.","large_file":"Votre photo dépasse 20 Mo. Veuillez choisir une image plus petite.","selected":"Photo sélectionnée — elle sera transférée lors de l’ajout au panier.","wait_variant":"Veuillez attendre la fin de la mise à jour. Si elle ne se termine pas, sélectionnez à nouveau l’option.","enter_name":"Veuillez saisir le nom à imprimer sur votre modèle.","total_size":"Vos photos ne doivent pas dépasser 20 Mo au total. Choisissez des images plus petites et réessayez.","reselect":"Veuillez sélectionner à nouveau l’option du produit avant de l’ajouter au panier."}};
  const fpLanguage = (document.documentElement.lang || "en").split("-")[0];
  const fpTranslate = key => (fpMessages[fpLanguage] || fpMessages.en)[key] || fpMessages.en[key];

  if (customElements.get('fiorpaw-personalisation')) return;
  class FiorpawPersonalisation extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.form = this.closest('form');
      this.section = this.closest('.shopify-section') || document;
      this.photos = [...this.querySelectorAll('[data-fp-photo]')];
      this.textFields = [...this.querySelectorAll('[data-fp-text]')];
      this.status = this.querySelector('[data-fp-status]');
      this.previews = new Map();
      for (const photo of this.photos) {
        photo.addEventListener('change', () => this.updatePhoto(photo), options);
        photo.closest('[data-fp-photo-field]').querySelector('[data-fp-remove]').addEventListener('click', () => {
          photo.value = '';
          this.updatePhoto(photo);
          photo.focus();
        }, options);
      }
      for (const field of this.textFields) field.addEventListener('input', () => field.setCustomValidity(''), options);
      document.addEventListener('variant:selected', event => {
        if (!this.ownsPicker(event.target)) return;
        this.variantPending = true;
        this.setStatus(fpTranslate('updating'));
      }, options);
      document.addEventListener('variant:update', event => {
        if (String(event.detail?.data?.productId) !== this.dataset.productId || !this.section.contains(event.target)) return;
        this.variantPending = false;
        this.dataset.variantId = String(event.detail?.resource?.id || '');
        this.syncStyle(event.detail?.resource);
        this.syncBundle(event.detail?.resource);
        this.setStatus(this.photos.some(p => p.files.length) ? fpTranslate('ready') : '');
      }, options);
      this.form.addEventListener('submit', event => {
        if (!this.validateForCart()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { ...options, capture: true });
      this.form.addEventListener('invalid', event => {
        const field = event.target;
        if (!this.contains(field)) return;
        // Constraint validation still blocks submission; replace the obscured native bubble.
        event.preventDefault();
        const message = field.matches('[data-fp-photo]') ? this.photoError(field) : fpTranslate('enter_name');
        field.setAttribute('aria-invalid', 'true');
        let error = field.parentElement.querySelector('.fp-field-error');
        if (!error) {
          error = document.createElement('p');
          error.className = 'fp-field-error';
          error.id = field.id + '-inline-error';
          error.setAttribute('role', 'alert');
          field.after(error);
          field.setAttribute('aria-describedby', [field.getAttribute('aria-describedby'), error.id].filter(Boolean).join(' '));
        }
        error.textContent = message || field.validationMessage;
        if (field === this.querySelector('input:invalid')) {
          requestAnimationFrame(() => {
            field.focus({ preventScroll: true });
            field.closest('.fp-personalisation__field')?.scrollIntoView({ block: 'center', behavior: 'instant' });
          });
        }
      }, { ...options, capture: true });
      const clearInlineError = event => {
        const field = event.target;
        if (!field.matches('[data-fp-photo], [data-fp-text]')) return;
        field.removeAttribute('aria-invalid');
        const error = field.parentElement.querySelector('.fp-field-error');
        if (error) error.textContent = '';
      };
      this.addEventListener('input', clearInlineError, options);
      this.addEventListener('change', clearInlineError, options);
      this.syncStyle();
      this.addEventListener('change', event => {
        if (event.target.matches('[data-fp-pet-mode]')) this.syncBundle();
      }, options);
      this.syncBundle();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      for (const url of this.previews?.values() || []) URL.revokeObjectURL(url);
      this.previews?.clear();
    }
    ownsPicker(target) {
      const picker = target?.closest?.('variant-picker');
      return picker && picker.dataset.productId === this.dataset.productId && this.section.contains(picker);
    }
    setStatus(message, error = false) {
      this.status.textContent = message;
      this.status.classList.toggle('fp-personalisation__status--error', error);
    }
    photoError(photo) {
      if (photo.disabled) return '';
      const file = photo.files[0];
      if (!file) return photo.required ? fpTranslate('choose_photo') : '';
      if (!/\.(jpe?g|png|webp|heic|heif)$/i.test(file.name)) return fpTranslate('choose_format');
      if (file.type && !/^image\/(jpeg|png|webp|heic|heif|heic-sequence|heif-sequence)$/i.test(file.type)) return fpTranslate('supported');
      if (!file.size) return fpTranslate('empty_file');
      if (file.size > 20 * 1024 * 1024) return fpTranslate('large_file');
      return '';
    }
    updatePhoto(photo) {
      const previous = this.previews.get(photo);
      if (previous) URL.revokeObjectURL(previous);
      this.previews.delete(photo);
      const file = photo.files[0];
      const field = photo.closest('[data-fp-photo-field]');
      const preview = field.querySelector('[data-fp-preview]');
      const thumbnail = field.querySelector('[data-fp-thumbnail]');
      const error = this.photoError(photo);
      photo.setCustomValidity(error);
      preview.hidden = !file || !!error;
      thumbnail.hidden = true;
      thumbnail.removeAttribute('src');
      if (!file) { this.setStatus(''); return; }
      if (error) { this.setStatus(error, true); photo.reportValidity(); return; }
      field.querySelector('[data-fp-filename]').textContent = file.name;
      if (!/\.hei[cf]$/i.test(file.name)) {
        const url = URL.createObjectURL(file);
        this.previews.set(photo, url);
        thumbnail.onerror = () => { thumbnail.hidden = true; };
        thumbnail.onload = () => { thumbnail.hidden = false; };
        thumbnail.src = url;
      }
      this.setStatus(fpTranslate('selected'));
    }
    syncStyle(variant) {
      const property = this.querySelector('[data-fp-style]');
      if (!property) return;
      const index = Number(property.dataset.optionIndex);
      const picker = this.section.querySelector('variant-picker[data-product-id="' + this.dataset.productId + '"]');
      const checked = picker?.querySelector('input[data-fieldset-index="' + index + '"]:checked');
      const select = picker?.querySelectorAll('select')[index];
      property.value = variant?.['option' + (index + 1)] || checked?.value || select?.value || property.value;
    }
    syncBundle(variant) {
      if (!this.hasAttribute('data-fp-bundle')) return;
      if (variant) this.dataset.bundleCount = String(parseInt(variant.option2, 10) || 1);
      const count = Math.max(1, Math.min(3, Number(this.dataset.bundleCount) || 1));
      const modes = this.querySelector('[data-fp-pet-modes]');
      modes.hidden = count === 1;
      modes.querySelectorAll('input').forEach(input => { input.disabled = count === 1; });
      const different = count > 1 && !!modes.querySelector('[value="Different pets"]:checked');
      this.querySelectorAll('[data-fp-pet-index]').forEach(group => {
        const active = Number(group.dataset.fpPetIndex) <= (different ? count : 1);
        group.hidden = !active;
        group.querySelectorAll('input').forEach(input => {
          input.disabled = !active;
          input.required = active && input.hasAttribute('data-fp-bundle-required');
          if (!active) input.setCustomValidity('');
        });
      });
    }
    validateForCart() {
      if (this.variantPending) {
        this.setStatus(fpTranslate('wait_variant'), true);
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
        this.status.scrollIntoView({ block: 'center', behavior: motion });
        return false;
      }
      for (const photo of this.photos) photo.setCustomValidity(this.photoError(photo));
      for (const field of this.textFields) {
        field.value = field.value.trim();
        field.setCustomValidity(!field.disabled && field.required && !field.value ? fpTranslate('enter_name') : '');
      }
      if (!this.form.reportValidity()) return false;
      if (this.photos.reduce((bytes, p) => bytes + (p.disabled ? 0 : (p.files[0]?.size || 0)), 0) > 20 * 1024 * 1024) {
        this.setStatus(fpTranslate('total_size'), true);
        return false;
      }
      if (!this.dataset.variantId || this.dataset.variantId !== this.form.querySelector('input[name="id"]')?.value) {
        this.setStatus(fpTranslate('reselect'), true);
        return false;
      }
      this.syncStyle();
      return true;
    }
  }
  customElements.define('fiorpaw-personalisation', FiorpawPersonalisation);
})();




